import script from "./ProductInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductInfo.vue?vue&type=script&setup=true&lang=js"

import "./ProductInfo.vue?vue&type=style&index=0&id=02c33f10&lang=css"

const __exports__ = script;

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QCard,QCardSection,QBtn,QImg});
